
// export const baseUrl = "http://localhost:7252/api/";
export const baseUrl = process.env.REACT_APP_API_URL;
export const baseUrlFile = process.env.REACT_APP_FILE_API_URL;
export const prepareHeaders = (headers) => {
    const token = localStorage.getItem("token");

    if (token) {
        headers.set('authorization', `Bearer ${token}`);

    }
    return headers;
}


